var exports = {
  "o": "x24da60e8--a475e5--agreement-link",
  "v": "x24da60e8--a475e5--agreement-disclaimer",
};

module.exports = exports;
